import {useMemo,useEffect,useState} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import {getSKUStockBalance} from '../../integration/Api.js'
import {getStockBalanceListBehavior} from '../../entities/Lists.js';
import {consoleLog} from '../../../core/utilities/Utilities.js';
const file='SKUDetailStockBalance.js';

const SKUDetailStockBalance=({parentId,application,userData,parent})=>{
    const [loading,setLoading]=useState(true);
    const [records,setRecords]=useState([]);
    const {getRowClassName,dataGridSx}=getStockBalanceListBehavior(application);
    
    const getRecords=(isSubscribed,sku_reference)=>{
        getSKUStockBalance({sku_reference:sku_reference})
        .then((data)=>{
            consoleLog({file:file,context:'getRecords - getStockBalance',arg_name:'data',arg_value:data});
            if(isSubscribed){
                if('error' in data){
                }
                else{
                    setRecords(data);
                }
            }
            setLoading(false);
        });
    };

    const handleClickEvent=async(args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'event',arg_value:args});
        switch(args?.action){
            case "refresh":
                setRecords([]);
                getRecords(true,parent?.reference?.value);
                break;
            default:
                break;
        }
    }

    useEffect(()=>{
        let isSubscribed=true;
        if(Object.keys(parent).length>0){
            const sku_reference=parent?.reference?.value;
            if(sku_reference!==undefined&&sku_reference!==null&&sku_reference!==''){
                getRecords(isSubscribed,sku_reference);
            }
            else{
                setLoading(false);
            }
        }
        return ()=>(isSubscribed=false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parent?.reference?.value]);

    const list_name='sku_stock_balance';

    const renderList=useMemo(()=>{
        const Component=COMPONENT_MAP['List'];
        return Component?(
            <Component
                records={records}
                list_name={list_name}
                loading={loading}
                height={'50vh'}
                file={file}
                application={application}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                canRemoveSelection={false}
                entityRules={{'entityRules':'false'}}
                userData={userData}
                focusOnSearchInput={true}
                handleClickEvent={handleClickEvent}
                handleSelection={null}
                filterComponent={null}
                getRowClassName={getRowClassName}
                dataGridSx={dataGridSx}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[loading,records])
    
    return(renderList);
}
export default SKUDetailStockBalance;